document.documentElement.classList.remove('no-js');

/* ===== Recently Viewed Tracker ===== */
(function () {
  var handle = document.body.dataset.productHandle;
  if (!handle) return;
  var KEY    = 'porodo_rv';
  var stored = [];
  try { stored = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch(e) {}
  stored = stored.filter(function(h) { return h !== handle; });
  stored.unshift(handle);
  stored = stored.slice(0, 20);
  try { localStorage.setItem(KEY, JSON.stringify(stored)); } catch(e) {}
})();


document.addEventListener('click', function(e){
  const btn=e.target.closest('[data-qty]');
  if(!btn) return;
  const input=document.querySelector(btn.dataset.qty);
  if(!input) return;
  const step=btn.dataset.step==='plus'?1:-1;
  input.value=Math.max(1,(parseInt(input.value||1,10)+step));
});
